import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';
// This Module's Components
import { YoungAdultPaxComponent } from './young-adult-pax.component';

@NgModule({
  imports: [CommonModule, HttpClientModule, ModalModule.forRoot()],
  declarations: [YoungAdultPaxComponent],
  exports: [YoungAdultPaxComponent]
})
export class YoungAdultPaxModule {}
